var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18L7.55 17.6625L7.54775 17.6609L7.5431 17.6573L7.52653 17.6447C7.51235 17.634 7.49195 17.6184 7.46577 17.5981C7.41342 17.5577 7.33783 17.4987 7.24228 17.4225C7.05133 17.2702 6.78027 17.0489 6.45592 16.7695C5.80824 16.2118 4.94234 15.4183 4.0739 14.4775C3.20768 13.5391 2.32407 12.4382 1.65351 11.2647C0.986487 10.0974 0.5 8.80575 0.5 7.5C0.5 3.35786 3.85786 0 8 0C12.1421 0 15.5 3.35786 15.5 7.5C15.5 8.80575 15.0135 10.0974 14.3465 11.2647C13.6759 12.4382 12.7923 13.5391 11.9261 14.4775C11.0577 15.4183 10.1917 16.2118 9.5441 16.7695C9.21972 17.0489 8.94868 17.2702 8.75772 17.4225C8.66218 17.4987 8.58658 17.5577 8.53423 17.5981C8.50805 17.6184 8.48765 17.634 8.47347 17.6447L8.4569 17.6573L8.45225 17.6609L8.45 17.6625L8 18ZM6.5 8.8125H9.5V5.8125H6.5V8.8125Z",
    fill: "#717C99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGrey);
export default __webpack_public_path__ + "static/media/locationGrey.001c33d4a09dc3dbcd48fa9d935c56de.svg";
export { ForwardRef as ReactComponent };